export const FILE_EXTENSIONS = {
  WORD_DOCUMENTS: ["doc", "docx"] as const,
  // Report Studio's document/LOI/bundle upload pipeline is PDF-only end to
  // end (see bundle_splitter/handler.py's explicit ".pdf" check, and the
  // vision-based summary/LOI-extraction Azure Functions it feeds). DOC/DOCX
  // used to be listed here too, but nothing downstream actually supported
  // them — a DOC upload would pass the client check and then fail silently
  // in the external pipeline (MDRS-272).
  DOCUMENTS: ["pdf"] as const,
  IMAGES: ["jpg", "jpeg", "png", "gif", "webp"] as const,
  SPREADSHEETS: ["xls", "xlsx", "csv"] as const,
} as const;

export const FILE_MIME_TYPES = {
  WORD_DOCUMENTS: [
    "application/msword", // .doc files
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx files
  ] as const,
  DOCUMENTS: [
    "application/pdf", // .pdf files
    "application/msword", // .doc files
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx files
  ] as const,
  IMAGES: [
    "image/jpeg", // .jpg, .jpeg files
    "image/png", // .png files
    "image/gif", // .gif files
    "image/webp", // .webp files
  ] as const,
  SPREADSHEETS: [
    "application/vnd.ms-excel", // .xls files
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx files
    "text/csv", // .csv files
  ] as const,
} as const;

export const FILE_SIZES = {
  MB_1: 1 * 1024 * 1024,
  MB_5: 5 * 1024 * 1024,
  MB_10: 10 * 1024 * 1024,
  MB_25: 25 * 1024 * 1024,
  MB_50: 50 * 1024 * 1024,
  MB_100: 100 * 1024 * 1024,
  MB_500: 500 * 1024 * 1024,
} as const;

export const DEFAULT_ALLOWED_EXTENSIONS = FILE_EXTENSIONS.WORD_DOCUMENTS;
export const DEFAULT_MAX_FILE_SIZE = FILE_SIZES.MB_10; // 10MB

export const FILE_TYPE_DESCRIPTIONS = {
  WORD_DOCUMENTS: "Word documents (.doc, .docx)",
  ALL_DOCUMENTS: "Document templates (.doc, .docx, .pdf, .txt)",
  IMAGES: "Images (.jpg, .jpeg, .png, .gif, .webp)",
  SPREADSHEETS: "Spreadsheets (.xls, .xlsx, .csv)",
} as const;
